import { SqliteJsonRepository } from './SqliteJsonRepository';
import type { Salarie } from '@shared/types/Salarie';

export class SqliteSalarieRepository extends SqliteJsonRepository<Salarie> {
  constructor() {
    super('salaries');
  }

  async findByTenantAndStatut(tenant_id: string, statut: Salarie['statut']): Promise<Salarie[]> {
    const rows = await this.findBy({ tenant_id, statut } as Partial<Salarie>);
    return rows;
  }

  async findActifs(tenant_id: string): Promise<Salarie[]> {
    return this.findByTenantAndStatut(tenant_id, 'actif');
  }

  async findByMatricule(tenant_id: string, matricule: string): Promise<Salarie | null> {
    const rows = await this.findBy({ tenant_id, matricule } as Partial<Salarie>);
    return rows[0] ?? null;
  }
}
